export default "__VITE_ASSET__CBOYL5Px__"